"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var BillingFrequencyBadge = (0, styles_1.styled)(material_1.Chip)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return ({
        borderRadius: 5,
        height: 20,
        width: 25,
        '& .MuiChip-label': {
            fontSize: theme.typography.fontSize,
            lineHeight: 1.3,
            letterSpacing: '-0.01em',
            textAlign: 'center',
            padding: 0,
        },
        '&[disabled]': {
            color: 'rgba(255, 255, 255, 0.35)',
            pointerEvents: 'none',
        },
        '&.MuiChip-colorPrimary, &.MuiChip-outlinedPrimary': {
            border: "1px solid ".concat(theme.palette.primary.main),
            color: theme.palette.primary.main,
        },
        '&.MuiChip-colorSecondary, &.MuiChip-outlinedSecondary': {
            border: '1px solid rgba(132, 71, 240, 0.6)',
            color: 'rgba(132, 71, 240, 0.6)',
        },
        '&.MuiChip-colorSuccess, &.MuiChip-outlinedSuccess': {
            border: "1px solid ".concat(theme.palette.success.main),
            color: theme.palette.success.main,
        },
        '&.MuiChip-colorError, &.MuiChip-outlinedError': {
            border: "1px solid ".concat((_b = theme.palette.red) === null || _b === void 0 ? void 0 : _b.main),
            color: (_c = theme.palette.red) === null || _c === void 0 ? void 0 : _c.main,
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(BillingFrequencyBadge, {
    variant: 'outlined',
});
